import {PanelSeparator} from '@eCommerce/frontend-legacy-shared-library-native';
import React from 'react';

import ConnectedBusinessInfoModule from 'containers/BusinessInfoModule';
import ConnectedCompanionSummary from 'containers/CompanionSummary';
import ConnectedPersonalInfoModule from 'containers/PersonalInfoModule';

const ConnectedProfileTab = () => {
  return (
    <>
      <ConnectedPersonalInfoModule />
      <PanelSeparator />
      <ConnectedBusinessInfoModule />
      <PanelSeparator />
      <ConnectedCompanionSummary />
    </>
  );
};

export default ConnectedProfileTab;
